export const DEFAULT_TEXT_SIZE = '14px';
export const DEFAULT_BORDER_RADIUS = '4px';
export const DEFAULT_HEIGHT = '48px';
export const DEFAULT_WIDTH = '452px';
export const DEFAULT_LINE_HEIGHT = '20PX';
export const DEFAULT_FORM_CONTAINER_WIDTH = '548px';
export const DEFAULT_FORM_CONTAINER_HEIGHT = '472px';
